export default [
  {
    path: "/bece",
    children: [
      //students
      {
        path: "students",
        name: "beceStudents",
        component: () => import("@/views/bece/student/index.vue"),
        meta: {
          title: "STUDENTS",
          authRequired: true,
          acc: 'y13985'
        },
      },
      //students
      {
        path: "studentslsi",
        name: "beceStudentsList",
        component: () => import("@/views/bece/student/list.vue"),
        meta: {
          title: "Students list",
          authRequired: true,
          acc: 'y54282'
        },
      },
      {
        path: "view-student/:id?",
        name: "beceStudent",
        component: () => import("@/views/bece/student/view.vue"),
        meta: {
          title: "VIEW STUDENT",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "edit-student/:id?",
        name: "beceEditStudent",
        component: () => import("@/views/bece/student/components/edit.vue"),
        meta: {
          title: "EDIT STUDENT",
          authRequired: true,
          acc: 'y37962'
        },
      },
      //register
      {
        path: "register",
        name: "bece-register",
        component: () => import("@/views/bece/register.vue"),
        meta: {
          title: "REGISTER",
          authRequired: true,
        },
      },
      //Cas
      {
        path: "cas",
        name: "beceCas",
        component: () => import("@/views/bece/cas/index.vue"),
        meta: {
          title: "BECE CAS",
          authRequired: true,
          acc: 'y15756'
        },
      },
      {
        path: "withca/:id",
        name: "beceWithCas",
        component: () => import("@/views/bece/cas/withca.vue"),
        meta: {
          title: "BECE With C.A",
          authRequired: true,
          acc: 'y15756'
        },
      },
      {
        path: "nonreg/:id?",
        name: "beceWithoutCas",
        component: () => import("@/views/bece/cas/withoutca.vue"),
        meta: {
          title: "BECE Without C.A",
          authRequired: true,
          acc: 'y15756'
        },
      },
      {
        path: "editca/:id?",
        name: "bece-editca",
        component: () => import("@/views/bece/cas/edit.vue"),
        meta: {
          title: "BECE UPDATE CA",
          authRequired: true,
          acc: 'y72410'
        },
      },
      //photo album
      {
        path: "photo_album",
        name: "bece-photo_album",
        component: () => import("@/views/bece/photo-album.vue"),
        meta: {
          title: "PHOTO ALBUM",
           authRequired: true,
        },
      },
      //gazette
      {
        path: "gazette",
        name: "bece-gazette",
        component: () => import("@/views/bece/gazette/index.vue"),
        meta: {
          title: "GAZETTE",
           authRequired: true,
        },
      },
      {
        path: "exam_card",
        name: "beceStudentsExamcard",
        component: () => import("@/views/bece/examcard.vue"),
        meta: {
          title: "EXAM CARD",
          authRequired: true,
          acc: 'y54282'

        },
      },
      //subject Analysis
      {
        path: "subject-analysis",
        name: "beceSubjectAnalysis",
        component: () => import("@/views/bece/subjectanalysis.vue"),
        meta: {
          title: "Subject Analysis",
           authRequired: true,
        },
      },
      //Attendance
      {
        path: "exam-subjects",
        name: "beceExamSubject",
        component: () => import("@/views/bece/attendance/List.vue"),
        meta: {
          title: "BECE Examination SUbject Attendance",
          authRequired: true,
          acc: 'y23369'
        },
      },
      {
        path: "mark-exam-attendance",
        name: "beceExamAttendance",
        component: () => import("@/views/bece/attendance/index.vue"),
        meta: {
          title: "BECE Examination Attendance",
          authRequired: true,
          acc: 'y23369'
        },
      },
      {
        path: "exam-attendance",
        name: "beceMExamAttendance",
        component: () => import("@/views/bece/attendance/view.vue"),
        meta: {
          title: "Marked BECE Examination Attendance",
          authRequired: true,
          acc: 'y23369'
        },
      },
    ],
  },
];
